export default __webpack_public_path__ + "static/media/reddit.0181b7dc.svg";